import * as actions from './actionTypes'
import Axios from 'axios'
export const  authStart = ()=>{
return{
    type:actions.AUTH_START,
    
}
}
export const  authFail = (error)=>{
    return{
        type:actions.AUTH_FAIL,
        error:error
    }
    }
export const redirect = ()=>{
    return{
        type:actions.RIDIRECT
    }
}
export const  authSuccess = (token)=>{
        console.log("authSuccess")
        console.log(token)
        return{
           type:actions.AUTH_SUCCESS,
           token:token,
        }
    }
export const logout = ()=>{
    localStorage.removeItem('token')
    localStorage.removeItem('expirationDate')
    localStorage.removeItem('course')
    localStorage.removeItem('stream')
    localStorage.removeItem('name')
    localStorage.removeItem('msg')
    return {
        type:actions.LOGOUT
    }
}
export const checkAuthTime= (expirationTime)=>{
    return dispatch=>{
    setTimeout(()=>{
       
        dispatch(logout())
    },expirationTime*1000)
}
}
export const clearError = ()=>{
    return {
        type:actions.CLEAR_ERROR
    }
}
export const auth = (email,password)=>{
    return (dispatch)=>{
        dispatch(authStart())
        const authData = {
            email:email,
            password:password,
        }
        console.log(authData)
        Axios.post("http://13.234.61.196:2222/login",authData)
        .then((response)=>{
            console.log(response)
            const expirationDate =  new Date((new Date().getTime() +3600*1000))
            localStorage.setItem('token',response.data.st)
            localStorage.setItem('expirationDate',expirationDate)
            localStorage.setItem('course',response.data.education_details.course_name)
            localStorage.setItem('name',response.data.user_profile.full_name)
            localStorage.setItem('stream',response.data.education_details.stream_name)
            localStorage.setItem('msg',response.data.trial_period.msg)
            dispatch(authSuccess(response.data.st))
            dispatch(checkAuthTime(3600))
            dispatch(redirect())
        })
        .catch((error)=>{
            if(!error.response){
            dispatch(authFail("No Internet Connection")) 
            }
            else{
                console.log(error.response.data.msg)
            dispatch(authFail(error.response.data.msg))
            }
        })
    }
}

export const checkAuthState = ()=>{
    return dispatch=>{
        const token = localStorage.getItem('token')
        if(!token){
            console.log("logout!!!")
            dispatch(logout())
        }
        else{
            const expirationDate = new Date(localStorage.getItem('expirationDate'))
            if((expirationDate<=new Date())){
               console.log("logout")
                dispatch(logout())
            }else{
            
         console.log("logedIn")  
        dispatch(authSuccess(localStorage.getItem('token')))
        dispatch(checkAuthTime((expirationDate.getTime()-new Date().getTime())/1000))
            }
        }
    }
}